import React, { useState, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import { TileButtonProps, TileButton } from '@printdeal/ui-library';
import LineItem from '../../../../../../types/cart/LineItem';
import RequestFileChangeModal from './RequestFileChangeModal';
import {
  dispatchAccountEvent,
  DispatchCategoriesAccount,
} from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface ChangeServiceButtonProps {
  lineItem: LineItem;
  dispatchEventCategory?: DispatchCategoriesAccount;
  thumbSize?: TileButtonProps['size'];
  thumbClasses?: string;
}

const RequestFileChangeThumbButton = ({
  lineItem,
  dispatchEventCategory = 'order_detail_interaction',
  thumbSize = 'lg',
  thumbClasses = '',
}: ChangeServiceButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (event: MouseEvent) => {
    event.preventDefault();
    setIsModalOpen(true);
    dispatchAccountEvent(dispatchEventCategory, 'modal_file_change_open');
  };

  const handleCloseModal = (eventName: string) => {
    setIsModalOpen(false);
    dispatchAccountEvent(dispatchEventCategory, eventName);
  };

  return (
    <>
      <span id={`changeServiceButton-${lineItem.id}`}>
        <TileButton
          size={thumbSize}
          icon="edit"
          onClick={handleOpenModal}
          className={thumbClasses}
        >
          <FormattedMessage id="account.order.service.requestFileChange.button" defaultMessage="Click here to request your file change." />
        </TileButton>
      </span>
      {
        isModalOpen && (
          <RequestFileChangeModal lineItem={lineItem} handleCloseModal={handleCloseModal} />
        )
      }
    </>
  );
};

export default RequestFileChangeThumbButton;
